import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  buttonText: {
    marginLeft: '7px'
  },
  activateSupplyChainButton: {
    marginRight: '12px',
    marginLeft: '12px'
  },
  actionButtonGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  navigationGroup:{
    display: 'flex',
    alignItems: 'center'
  },
  contextNameButton: {
    marginRight: '12px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px 10px',
    borderRadius: '8px',
    cursor: 'pointer',

  },
  contextNameButtonText: {
    color: theme.palette.grey.grey400,
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '12px',
    marginLeft: '4.4px',
    marginRight: '7.5px',
    paddingTop: '2px',
    maxWidth: '300px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  contextIcon: {
    marginLeft: '5px',
    height: '20px',
    width: '20px'
  },
  titleHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  topHeaderIcon: {
    backgroundColor: theme.palette.grey.grey100,
    padding: "9px",
    borderRadius: "50%",
    marginBottom: "1rem",
    width: "55px",
    overflow: "visible",
  },
  archiveTitle: {
    fontSize: "18px",
    fontWeight: 600,
    fontFamily: "Inter",
    color: theme.palette.grey.grey700,
    marginBottom: "8px",
  },
  archiveSubTitle: {
    fontSize: "14px",
    color: theme.palette.grey.grey500,
    marginBottom: "32px",
  }
}));

export default useStyles;
